"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentationMode = void 0;
/**
 * The segmentation mode.
 */
var SegmentationMode;
(function (SegmentationMode) {
    SegmentationMode["Normal"] = "Normal";
    SegmentationMode["Disabled"] = "Disabled";
    SegmentationMode["Custom"] = "Custom";
    SegmentationMode["Semantic"] = "Semantic";
})(SegmentationMode = exports.SegmentationMode || (exports.SegmentationMode = {}));

//# sourceMappingURL=Segmentation.js.map
